
import { Toggle } from '05-ui-kit';
import { computed } from '@vue/composition-api';
import TSProductRating from '~/components/ts-components/TSProductRating/TSProductRating.vue';
import ColorAvatar from '~/components/ColorAvatar/ColorAvatar.vue';
import type { Review } from '~/type/Review';
import { useAuthStore } from '~/store/modal/auth';
import { useUserStore } from '~/store/user';
interface Props {
  /**
   * Данные отзыва
   */
  review: Review;
  /**
   * Открыто ли поле для ответа
   */
  activeField?: boolean;
  /**
   * Открывать ли поле для ответа при клике на кнопку "ответить"
   */
  showFieldButton?: boolean;
  /**
   * Показывать ли иконку количества комментариев
   */
  showCommentIcon?: boolean;
}
const __sfc_main = {};
__sfc_main.props = {
  review: {
    key: "review",
    required: true,
    type: null
  },
  activeField: {
    key: "activeField",
    required: false,
    type: Boolean,
    default: false
  },
  showFieldButton: {
    key: "showFieldButton",
    required: false,
    type: Boolean,
    default: true
  },
  showCommentIcon: {
    key: "showCommentIcon",
    required: false,
    type: Boolean,
    default: true
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const emit = __ctx.emit;
  const {
    enable: enableAuthModal
  } = useAuthStore();
  const userStore = useUserStore();
  const userAuth = computed(() => userStore.userAuth);
  function onClickPositive() {
    if (userAuth.value) {
      /**
      * Срабатывает при клике на лайк только у авторизованных пользователей
      */
      emit('positive');
    } else {
      enableAuthModal({
        onComplete: () => emit('positive')
      });
    }
  }
  function onClickNegative() {
    if (userAuth.value) {
      /**
      * Срабатывает при клике на дизлайк только у авторизованных пользователей
      */
      emit('negative');
    } else {
      enableAuthModal({
        onComplete: () => emit('negative')
      });
    }
  }
  function onAnswer(cb: () => Promise<void>) {
    if (userAuth.value) {
      cb();
    } else {
      enableAuthModal({
        onComplete: () => cb()
      });
    }
  }
  function onClickAnswer({
    click
  }: {
    click: () => Promise<void>;
  }) {
    emit('click-answer');
    props.showFieldButton && onAnswer(click);
  }
  return {
    emit,
    onClickPositive,
    onClickNegative,
    onClickAnswer
  };
};
__sfc_main.components = Object.assign({
  ColorAvatar,
  TSProductRating,
  Toggle
}, __sfc_main.components);
export default __sfc_main;
